import {
  IGetUserSettingPayload,
  IGetUserSettingResponse,
  IPostUserSettingPayload,
  IPostUserSettingResponse,
} from '../models/user.model'
import axiosInstance from '../utils/api-util/utilApi'

export const saveUserSetting = (payload: IPostUserSettingPayload): Promise<IPostUserSettingResponse> => {
  const url = `/userSetting`
  return axiosInstance.post(url, JSON.stringify(payload))
}

export const updateUserSetting = (payload: IPostUserSettingPayload): Promise<IPostUserSettingResponse> => {
  const url = `/userSetting`
  return axiosInstance.put(url, JSON.stringify(payload))
}

export const getUserSetting = (payload: IGetUserSettingPayload): Promise<IGetUserSettingResponse> => {
  const url = `/userSettings?UserId=${payload.userId}&TableName=${payload.tableName}`
  return axiosInstance.get(url)
}
